module.exports = __webpack_public_path__ + "static/img/bank_qrcode.1d8026f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank_qrcode.jpg
// module id = 23kF
// module chunks = 1